<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import {
		API,
		cabecalhoPadraoRequisicao,
		gerarStringAleatoria,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';
	import {sCaptcha} from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let senha, captchaUsuario;
	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let coordenadorRetornado, papelDiscente;
	let divInformacoesDiscente;
	let discenteSelecionadoHtml;
	let codigoProjeto;
	let cpfCoordenador;
	let botaoEnvioDesabilitado = true;

	onMount(async () => {
		if (!verificarSessionStorage('AVAL_TOKEN'))
			 replace("/login");

		divInformacoesDiscente = document.getElementById('boxInformacoesCoordenador');
	});

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Indicando ...',
		});
			
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
			const resposta = await fetch(API('projetos/indicar'), {
				method: 'POST',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					senha: senha,
					codigo: codigoProjeto,
					cpf: cpfCoordenador,
					papel: papelDiscente
				})
			}).catch(erros => {
				feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
				
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			});

			// pega o json do retorno da resposta
			const json = await resposta.json();

			if (resposta.status == StatusHttp.OK) {		
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Tudo certo!',
					conteudo: json?.mensagem
				});

				replace('#/painel/projetos');
			} else if (resposta.status == StatusHttp.UNPROCESSABLE_ENTITY) {
				tituloAviso = 'Verifique os dados informados!'
				feedbackUsuario.push(json?.mensagem);
			} else {
				feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
			}

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});

			// exibe feedback pro usuário se existir algo pra exibir
			if (feedbackUsuario[0]) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			}

			// limpa as mensagens
			feedbackUsuario = [];
		}
	}
	
	async function buscarCoordenadorPorCPF(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Buscando ...',
		});
			
		// faz a chamada a API no endpoint buscar-discente-por-cpf, envia os dados e aguarda a resposta
		const resposta = await fetch(API('buscar-discente-por-cpf'), {
			method: 'POST',
			headers: cabecalhoPadraoRequisicao(),
			body: JSON.stringify({
				cpf: cpfCoordenador,
			})
		}).catch(erros => {
			feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
			
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		});

		// pega o json do retorno da resposta
		const json = await resposta.json();
		
		if (resposta.status == StatusHttp.OK) {
			coordenadorRetornado = json.dados;

			discenteSelecionadoHtml = `
				<p>Coordenador(a): <strong>${coordenadorRetornado.nome}</strong></p>
				<p>Matrícula: <strong>${esconderPartesMatricula(coordenadorRetornado.matricula)}</strong></p>
				<p>Unidade: <strong>${coordenadorRetornado.unidade}</strong></p>
			`;

			botaoEnvioDesabilitado = false;
		} else if (resposta.status == StatusHttp.HTTP_NOT_FOUND) {
			feedbackUsuario.push('Coordenador não encontrado com o CPF informado.');
		} else {
			feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		// exibe feedback pro usuário se existir algo pra exibir
		if (feedbackUsuario[0]) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		}

		// limpa as mensagens
		feedbackUsuario = [];
	}

	const esconderPartesMatricula = (matricula) => matricula.replace(/\d(?<=\d{4})\d(?=\d{2})/g, "##");
</script>

<TBox 
	titulo="Indicação Coordenador"
	subtitulo="Utilize o formulário abaixo para realizar indicação de coordenador"
	largura="8" 
	deslocamento="2" 
	correcaoY="-13px"
	icone="indicar">
	
	<form method="post" on:submit|preventDefault={submeterFormulario} autocomplete="off">
		<p>Informe o código do projeto:</p>
		
		<div class="columns">
			<div class="column">
				<div class="control is-expanded">
					<input
						bind:value={codigoProjeto}
						name="codigo_projeto"
						type="tel"
						pattern="[0-9]*"
						maxlength="20"
						placeholder="Somente números..."
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>

		<p>Digite o CPF do usuário que irá coordenar o projeto:</p>
		<div class="columns">
			<div class="column">
				<div class="field has-addons">
					<div class="control is-expanded">
						<input 
							bind:value={cpfCoordenador}
							name="cpf_discente"
							type="tel" 
							pattern="[0-9]*"
							maxlength="11"
							placeholder="Somente números..." 
							class="input is-large is-primary" required>
					</div>
					<div class="control">
						<button class="button is-info is-large" on:click|preventDefault={buscarCoordenadorPorCPF}>Buscar</button>
					</div>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<span class="tag">RESUMO DO(A) COORDENADOR(A):</span>
				<div class="box" id="boxInformacoesCoordenador">
					{#if discenteSelecionadoHtml}
					{@html discenteSelecionadoHtml}
					{:else}
					<p>Informações do(a) coordenador(a) serão exibidas aqui após a busca.</p>
					{/if}
				</div>
			</div>
		</div>

		<p>Selecione o papel que o(a) indicado(a) exercerá no projeto:</p>
		<div class="columns">
			<div class="column">
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={papelDiscente} name="papel" required>
						<option value="">Selecione...</option>
						<option value="SUPERVISOR">Supervisor(a)</option>
						<option value="ORIENTADOR">Orientador(a)</option>
					</select>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<div class="field">
					<input 
						bind:value={senha}
						name="senha" 
						type="password" 
						placeholder="Informe sua senha" 
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>

		<div class="columns is-mobile">
			<div class="column">
				<Captcha />
			</div>
			<div class="column">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/painel" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						disabled={botaoEnvioDesabilitado}
						class="button is-success is-medium is-fullwidth">
						Indicar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>